import routers from "./routers";
import { Provider } from "react-redux";
// import store from "./redux-setup/store";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./shared/components/Layout/Footer";
import Header from "./shared/components/Layout/Header";
import Menu from "./shared/components/Layout/Menu";
import Sidebar from "./shared/components/Layout/Sidebar";
import Slider from "./shared/components/Layout/Slider";

import { PersistGate } from "redux-persist/integration/react";
import { store, persistorHau } from "./redux-setup/store";

const App = () => {
  return (
    <>
      <Provider store={store}>
        <PersistGate persistor={persistorHau}>
          <BrowserRouter>
            <div>
              <Header />
              {/*	Body	*/}
              <div id="body">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <Menu />
                    </div>
                  </div>
                  <div className="row">
                    <div id="main" className="col-lg-8 col-md-12 col-sm-12">
                      <Slider />
                      <Routes>
                        {routers.map((item, index) => (
                          <Route
                            key={index}
                            path={item.path}
                            element={<item.element />} //require tag format so have < />
                          />
                        ))}
                      </Routes>
                    </div>
                    <Sidebar />
                  </div>
                </div>
              </div>
              {/*	End Body	*/}
              <Footer />
            </div>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </>
  );
};
export default App;
